export const GOOGLE_PLACE_MAPS_API_KEY =
  'AIzaSyDnt7jB6LL5RnmfuTo44SIMl3N37oaHs88';
